import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Thunk to add or remove a counsellor from user's favourites.
 * @param {Object} payload - The payload object containing favouriteId, pcUserId, and counsellorId.
 * @returns {Promise<Object>} The API response data or an error message.
 */
export const addRemoveFavourite = createAsyncThunk(
  "api/addRemoveFavourite",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_BASE_URL}/user/favourite`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );
      const status = "success";
      const data = {
        status: status,
        message: response.data,
      };
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update favourites."
      );
    }
  }
);

const addRemoveFavouriteSlice = createSlice({
  name: "addRemoveFavourite",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRemoveFavourite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addRemoveFavourite.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addRemoveFavourite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unexpected error occurred.";
      });
  },
});

export default addRemoveFavouriteSlice.reducer;
